/**
 * SVG path data for the Raina character mascot.
 * Organized by body part for maintainability.
 */

export const bodyPaths = {
  rightLeg: 'M0 74.4253V0H48.4597C48.4597 0 45.8457 41.3531 24.7404 65.2868C14.5093 80.9601 0 74.4253 0 74.4253Z',
  leftLeg: 'M48.4597 74.4253V0H0C0 0 2.61392 41.3531 23.7193 65.2868C33.9504 80.9601 48.4597 74.4253 48.4597 74.4253Z',
  rightShoeShape: 'M96.2046 43.9874L96.2057 43.9876C96.2057 6.35324 59.1299 5.1693e-06 3.8455e-06 0L0 43.9874L96.2046 43.9874Z',
  leftShoeShape: 'M96.2046 43.9874L96.2057 43.9876C96.2057 6.35324 59.13 5.1693e-06 4.11973e-05 0L3.73518e-05 43.9874L96.2046 43.9874Z',
  rightShoeLace1:
    'M27.983 18.3986C32.8521 18.3986 36.7993 14.4513 36.7993 9.58219V-3.06737H19.1666V9.58219C19.1666 14.4513 23.1138 18.3986 27.983 18.3986Z',
  rightShoeLace2:
    'M49.4488 18.3986C54.3179 18.3986 58.2651 14.4513 58.2651 9.58219V-3.06737H40.6324V9.58219C40.6324 14.4513 44.5796 18.3986 49.4488 18.3986Z',
  leftShoeLace1:
    'M27.9801 18.3986C32.8492 18.3986 36.7964 14.4513 36.7964 9.58219V-3.06737H19.1637V9.58219C19.1637 14.4513 23.1109 18.3986 27.9801 18.3986Z',
  leftShoeLace2:
    'M49.4459 18.3986C54.315 18.3986 58.2623 14.4513 58.2623 9.58219V-3.06737H40.6295V9.58219C40.6295 14.4513 44.5767 18.3986 49.4459 18.3986Z',
  leftArm: 'M48.6739 69.9377L42.1259 94.3743L80.0291 106.045L106.492 7.2832C78.7226 14.724 59.6537 28.9609 48.6739 69.9377Z',
  rightArm: 'M254.002 69.6819L260.55 94.1184L222.646 105.789L196.183 7.02734C223.953 14.4681 243.022 28.705 254.002 69.6819Z',
  torsoBase:
    'M208.928 0H152.463H95.9981L68.4192 151.271C65.9176 163.902 75.5768 175.664 88.4524 175.664H216.473C229.349 175.664 239.008 163.902 236.507 151.271L208.928 0Z',
  hoodiePocket:
    'M204.15 129.462C204.15 134.516 200.229 138.692 195.195 139.029C181.911 139.917 167.8 140.438 152.954 140.448C137.74 140.459 123.302 139.928 109.732 139.029C104.688 138.692 100.767 134.516 100.767 129.462V98.5541C100.767 93.51 104.678 89.3339 109.712 88.9867C123.466 88.0473 138.128 87.496 153.618 87.5266C168.25 87.5572 182.136 88.0882 195.216 88.9867C200.25 89.3339 204.15 93.51 204.15 98.5541V129.462Z',
};

export const headPaths = {
  face: 'M359.554 136.845C359.554 212.424 273.423 273.691 179.772 273.691C86.1214 273.691 0 212.424 0 136.845C0 61.2663 86.1316 0 179.772 0C273.413 0 359.554 61.2663 359.554 136.845Z',
  bangsShape:
    'M-15.9095 117.366C-15.9095 117.366 69.4134 107.059 162.061 19.5415C151.764 54.8186 106.793 86.8959 106.793 86.8959C106.793 86.8959 179.104 99.8719 246.73 33.7335C274.696 87.7934 346.478 114.108 373.545 117.327C391.432 -7.38 263.508 -69.9945 201.816 -71.7776C67.3987 -71.7776 22.4176 -23.12 -16.932 60.0845L-15.9095 117.366Z',
  ponytailMask:
    'M117.237 99.7364C52.2463 114.486 4.53061 82.0949 0.114647 49.5758L85.0385 0.074373C97.4804 10.0394 113.51 19.7484 103.438 61.021C97.3898 85.8034 109.047 94.0056 117.237 99.7364Z',
  ponytailColor:
    'M132.123 111.909C50.6274 130.404 -9.20555 89.7877 -14.7429 49.0104L91.7472 -13.0618C107.349 -0.566188 127.449 11.6084 114.819 63.3621C107.235 94.4379 121.852 104.723 132.123 111.909Z',
};

export const hoodiePaths = {
  hood: 'M392.52 174.812C392.52 267.11 298.495 334.255 196.255 334.255C94.0154 334.255 0 267.11 0 174.812C0 71.9837 65.2613 0 196.255 0C327.249 0 392.52 70.8311 392.52 174.812Z',
  ear: 'M0.0101894 33.0024C0.0101894 33.0024 34.0831 -17.4892 97.7566 6.43434C114.002 65.8909 58.9868 100.566 58.9868 100.566L0 33.0024H0.0101894Z',
  hornBase:
    'M36.2589 5.44482L3.55189 97.2933C1.63682 102.671 4.70768 108.541 10.2176 110.034C32.4011 116.047 55.7783 116.099 77.9884 110.185L78.5201 110.044C84.1402 108.547 87.2842 102.57 85.3331 97.0916L52.698 5.44482C49.6246 -1.81494 39.3323 -1.81494 36.2589 5.44482Z',
  hornMask:
    'M36.2579 5.4458L3.73001 96.7914C1.71835 102.441 4.94409 108.606 10.732 110.175C32.5779 116.096 55.5994 116.147 77.4715 110.324L77.9933 110.185C83.8965 108.613 87.199 102.335 85.1496 96.58L52.697 5.4458C49.6236 -1.81396 39.3313 -1.81396 36.2579 5.4458Z',
  hornStripe1: 'M-2.24231 99.6638L94.1283 28.3662',
  hornStripe2: 'M24.9491 119.596L121.32 48.2988',
  hornStripe3: 'M-0.328195 58.6829L84.1586 -3.06543',
  rightCollar:
    'M51.0384 15.1258C63.3725 20.7478 54.5086 35.882 51.0384 34.5473C38.4949 29.7229 19.4373 19.5382 2.29526 7.10759C-6.90442 -1.93288 13.5393 -2.02934 28.4443 7.10759C34.71 10.9485 41.9669 13.7749 51.0384 15.1258Z',
  leftCollar:
    'M52.7332 14.8347C40.3991 20.4568 49.263 35.591 52.7332 34.2563C65.2767 29.4319 84.3343 19.2472 101.476 6.81657C110.676 -2.22389 90.2323 -2.32036 75.3273 6.81657C69.0616 10.6575 61.8047 13.4838 52.7332 14.8347Z',
  stringCurve: 'M3.8332 3.8332C3.8332 3.8332 11.6954 11.5116 11.9098 25.6737',
  stringTailRight: 'M12.0949 28.3615L12.5194 36.0319',
  stringTailLeft: 'M12.2648 28.3615L12.6893 36.0319',
};

// Mouth center: ~x=98.87, y=88. Keep all paths within y=96 max to avoid clipping in viewBox (0 0 197 103.567).
export const mouthPaths = {
  neutral: 'M115 88C110 88 104 88 98.8718 88C93.7 88 87.7 88 83 88',
  smile: 'M120.832 80.8644C120.832 91.5886 111.001 100.29 98.8718 100.29C86.7427 100.29 76.9121 91.596 76.9121 80.8644',
  proud: 'M120 80C120 92 111 96 98.8718 96C86.7 96 77.7 92 77.7 80',
  impressed: 'M122 78C122 90 112 95 98.8718 95C85.7 95 75.7 90 75.7 78',
  listening: 'M113 86C113 88 107 90 98.8718 90C91 90 85 88 85 86',
  curious: 'M119 82C119 91 111 96 98.8718 95C87 94 79 89 79 83',
  thinking: 'M110 87C110 85 107 84 103 84C99 84 95 86 93 89',
  focused: 'M113 87C109 86 104 86 98.8718 86C93.7 86 88.7 86 84.7 87',
  concerned: 'M114 92C114 92 108 85 98.8718 85C89.7 85 83.7 92 83.7 92',
  apologetic: 'M114 85C114 85 110 83 98.8718 83C87.7 83 83.7 85 83.7 85L84 91C88 90 94 89 98.8718 89C103.7 89 109.7 90 113.7 91L114 85Z',
  confused: 'M116 88C112 84 106 83 98.8718 86C91.7 89 86 93 82 91',
  surprised: 'M108 80C108 80 108 76 98.8718 76C89.7 76 89.7 80 89.7 80C89.7 80 87 90 98.8718 93C110.7 90 108 80 108 80Z',
  talkOpen: 'M116 82C116 82 112 78 98.8718 78C85.7 78 81.7 82 81.7 82C81.7 82 78 92 98.8718 96C119.7 92 116 82 116 82Z',
  talkClosed: 'M112 84C112 84 108 82 98.8718 82C89.7 82 85.7 84 85.7 84C85.7 84 83 90 98.8718 92C114.7 90 112 84 112 84Z',
  tired: 'M112 84C112 84 107 81 98.8718 81C90.7 81 85.7 84 85.7 84C85.7 84 84 90 98.8718 92C113.7 90 112 84 112 84Z',
  excited: 'M120 78C120 78 115 74 98.8718 74C82.7 74 77.7 78 77.7 78C77.7 78 75 90 98.8718 95C122.7 90 120 78 120 78Z',
  celebrating: 'M122 76C122 76 116 72 98.8718 72C81.7 72 75.7 76 75.7 76C75.7 76 72 90 98.8718 96C125.7 90 122 76 122 76Z',
  patient: 'M114 86C114 89 108 92 98.8718 92C89.7 92 83.7 89 83.7 86',
  skeptical: 'M116 87C114 85 108 84 98.8718 86C89.7 88 85 91 83 92',
};

export const eyePaths = {
  rightEyeWhite:
    'M163.897 22.2359C182.179 22.2359 197 37.2308 197 55.728C197 74.2252 182.179 89.2202 163.897 89.2202C145.614 89.2202 130.793 74.2252 130.793 55.728C130.793 37.2308 145.614 22.2359 163.897 22.2359Z',
  rightPupil:
    'M164.375 22.5961C177.951 22.5961 188.957 33.8423 188.957 47.7152C188.957 61.5881 177.951 72.8343 164.375 72.8343C150.799 72.8343 139.793 61.5881 139.793 47.7152C139.793 33.8423 150.799 22.5961 164.375 22.5961Z',
  rightEyebrow: 'M145.411 10.7753C154.916 0.614675 174.582 0.94334 183.431 10.7753',
  leftEyeWhite:
    'M33.1035 21.9196C51.386 21.9196 66.207 36.9145 66.207 55.4117C66.207 73.9089 51.386 88.9038 33.1035 88.9038C14.8209 88.9038 0 73.9089 0 55.4117C0 36.9145 14.8209 21.9196 33.1035 21.9196Z',
  leftPupil:
    'M33.5818 22.2777C47.1579 22.2777 58.1636 33.5239 58.1636 47.3968C58.1636 61.2697 47.1579 72.5159 33.5818 72.5159C20.0056 72.5159 9 61.2697 9 47.3968C9 33.5239 20.0056 22.2777 33.5818 22.2777Z',
  leftEyebrow: 'M13.4358 10.7755C22.9407 0.614853 42.6062 0.943517 51.4556 10.7755',
};

/** Eye center positions in SVG coordinates (derived from pupil path centers). */
export const eyeCenters = {
  right: { x: 164, y: 47 },
  left: { x: 33.5, y: 47 },
};

/**
 * Eyebrow transforms per expression (rotation in degrees, translateY in SVG units).
 *
 * Based on FACS (Facial Action Coding System):
 * - AU1: Inner brow raiser (worry) — negative rotation lifts inner corner
 * - AU2: Outer brow raiser (surprise) — positive rotation lifts outer corner
 * - AU4: Brow lowerer (concentration) — positive translateY lowers brow
 *
 * Positive rotation = clockwise for both left and right eyebrows.
 */
export const eyebrowTransforms = {
  neutral: { left: { rotate: 0, translateY: 0 }, right: { rotate: 0, translateY: 0 } },
  happy: { left: { rotate: -6, translateY: -2 }, right: { rotate: 6, translateY: -2 } },
  proud: { left: { rotate: -10, translateY: -5 }, right: { rotate: 10, translateY: -5 } },
  impressed: { left: { rotate: -5, translateY: -8 }, right: { rotate: 5, translateY: -8 } },
  listening: { left: { rotate: 0, translateY: -2 }, right: { rotate: 0, translateY: -2 } },
  curious: { left: { rotate: 2, translateY: 0 }, right: { rotate: -14, translateY: -7 } },
  thinking: { left: { rotate: 5, translateY: 1 }, right: { rotate: -8, translateY: -3 } },
  focused: { left: { rotate: 6, translateY: 4 }, right: { rotate: -6, translateY: 4 } },
  concerned: { left: { rotate: -12, translateY: 0 }, right: { rotate: 12, translateY: 0 } },
  apologetic: { left: { rotate: -14, translateY: -2 }, right: { rotate: 14, translateY: -2 } },
  confused: { left: { rotate: 10, translateY: 5 }, right: { rotate: -18, translateY: -8 } },
  surprised: { left: { rotate: -3, translateY: -9 }, right: { rotate: 3, translateY: -9 } },
  talking: { left: { rotate: -3, translateY: -1 }, right: { rotate: 3, translateY: -1 } },
  tired: { left: { rotate: 3, translateY: 6 }, right: { rotate: -3, translateY: 6 } },
  excited: { left: { rotate: -8, translateY: -7 }, right: { rotate: 8, translateY: -7 } },
  celebrating: { left: { rotate: -6, translateY: -10 }, right: { rotate: 6, translateY: -10 } },
  patient: { left: { rotate: -2, translateY: 0 }, right: { rotate: 2, translateY: 0 } },
  skeptical: { left: { rotate: 4, translateY: 2 }, right: { rotate: -14, translateY: -6 } },
};

/**
 * Eyelid positions per expression (translateY in px).
 *
 * Scale: -100 = fully open, -55 = half closed, 0 = fully closed.
 * Asymmetric values create wink/squint effects.
 */
export const eyelidPositions = {
  neutral: { left: -100, right: -100 },
  happy: { left: -72, right: -72 },
  proud: { left: -70, right: -70 },
  impressed: { left: -100, right: -100 },
  listening: { left: -100, right: -100 },
  curious: { left: -90, right: -100 },
  thinking: { left: -70, right: -88 },
  focused: { left: -68, right: -68 },
  concerned: { left: -70, right: -70 },
  apologetic: { left: -85, right: -85 },
  confused: { left: -58, right: -98 },
  surprised: { left: -100, right: -100 },
  talking: { left: -88, right: -88 },
  tired: { left: -52, right: -55 },
  excited: { left: -100, right: -100 },
  celebrating: { left: -72, right: -72 },
  patient: { left: -85, right: -85 },
  skeptical: { left: -70, right: -95 },
};

/**
 * Eye shape transforms per expression (CSS transforms on eye white and pupil groups).
 *
 * Value ranges to keep pupil within eye white bounds:
 * - eyeWhite.scaleY: 0.82–1.05 | eyeWhite.scaleX: 0.98–1.03 | eyeWhite.translateY: -3 to 3
 * - pupil.scale: 0.92–1.04 | pupil.translateY: 2–8 (pupil paths sit ~8 units above center, so 4–6 = centered)
 */
export const eyeShapeTransforms = {
  neutral: {
    eyeWhite: { scaleX: 1, scaleY: 1, translateY: 0 },
    pupil: { scale: 1, translateY: 5 },
  },
  happy: {
    eyeWhite: { scaleX: 1, scaleY: 0.92, translateY: 1 },
    pupil: { scale: 1, translateY: 4 },
  },
  proud: {
    eyeWhite: { scaleX: 1, scaleY: 0.93, translateY: 1 },
    pupil: { scale: 1, translateY: 6 },
  },
  impressed: {
    eyeWhite: { scaleX: 1.02, scaleY: 1.05, translateY: -1 },
    pupil: { scale: 1.04, translateY: 4 },
  },
  listening: {
    eyeWhite: { scaleX: 1, scaleY: 1.02, translateY: 0 },
    pupil: { scale: 1.03, translateY: 5 },
  },
  curious: {
    eyeWhite: { scaleX: 1.02, scaleY: 1.04, translateY: -1 },
    pupil: { scale: 1.03, translateY: 3 },
  },
  thinking: {
    eyeWhite: { scaleX: 1, scaleY: 0.95, translateY: 0 },
    pupil: { scale: 1, translateY: 2 },
  },
  focused: {
    eyeWhite: { scaleX: 0.98, scaleY: 0.9, translateY: 0 },
    pupil: { scale: 0.98, translateY: 5 },
  },
  concerned: {
    eyeWhite: { scaleX: 1, scaleY: 0.94, translateY: 1 },
    pupil: { scale: 1, translateY: 7 },
  },
  apologetic: {
    eyeWhite: { scaleX: 1, scaleY: 1, translateY: 0 },
    pupil: { scale: 1, translateY: 6 },
  },
  confused: {
    eyeWhite: { scaleX: 1, scaleY: 0.88, translateY: 0 },
    pupil: { scale: 1, translateY: 4 },
  },
  surprised: {
    eyeWhite: { scaleX: 1.03, scaleY: 1.05, translateY: -1 },
    pupil: { scale: 1.04, translateY: 4 },
  },
  talking: {
    eyeWhite: { scaleX: 1, scaleY: 1, translateY: 0 },
    pupil: { scale: 1.01, translateY: 5 },
  },
  tired: {
    eyeWhite: { scaleX: 1, scaleY: 0.82, translateY: 3 },
    pupil: { scale: 0.94, translateY: 8 },
  },
  excited: {
    eyeWhite: { scaleX: 1.02, scaleY: 1.04, translateY: -1 },
    pupil: { scale: 1.04, translateY: 4 },
  },
  celebrating: {
    eyeWhite: { scaleX: 1, scaleY: 0.92, translateY: 1 },
    pupil: { scale: 1.04, translateY: 4 },
  },
  patient: {
    eyeWhite: { scaleX: 1, scaleY: 0.96, translateY: 0 },
    pupil: { scale: 1, translateY: 5 },
  },
  skeptical: {
    eyeWhite: { scaleX: 1, scaleY: 0.94, translateY: 0 },
    pupil: { scale: 1, translateY: 5 },
  },
};
